import React from 'react';

const HeaderIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-header" />
    </div>
  );
};

export default HeaderIcon;
